import type { DataTableAlign } from './types.ts';

export const alignClass: Record<DataTableAlign, string> = {
  start: 'text-left',
  center: 'text-center',
  end: 'text-right',
};
